import "./serviceList.css";

const ServiceList = () => {
  return (
    <div>
      <section className="service pt-4 pb-3">
        <div className="container">
          <div className="default-section-title default-section-title-middle">
            <h3>Nos services</h3>
          </div>
          <div className="row d-flex">
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/web.webp"
                    alt="Développement Web"
                  />
                  <i className="bi bi-browser-chrome"></i>
                </div>
                <div className="service-card-text">
                  <h4>Développement d'Applications Web</h4>
                  <p>
                    Conception et développement d’applications web sur mesure,
                    performantes et sécurisées, adaptées à vos besoins.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/mobile.webp"
                    alt="Développement Mobile"
                  />
                  <i className="bi bi-phone-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Développement d'Applications Mobiles</h4>
                  <p>
                    Création d’applications mobiles natives et hybrides pour
                    Android et iOS, offrant une expérience fluide et intuitive.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/hebergement.webp"
                    alt="Hébergement"
                  />
                  <i className="bi bi-cloud-arrow-down-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Hébergement et Gestion de Code</h4>
                  <p>
                    Solutions d'hébergement performantes et sécurisées pour vos
                    applications et sites web, avec gestion et maintenance du
                    code.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/reseau.webp"
                    alt="Installation Réseau"
                  />
                  <i className="bi bi-hdd-network"></i>
                </div>
                <div className="service-card-text">
                  <h4>Installation Réseau</h4>
                  <p>
                    Mise en place de réseaux informatiques fiables et sécurisés
                    pour vos bureaux, entreprises ou résidences, adaptés à vos
                    besoins.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/camera.webp"
                    alt="Sécurité"
                  />
                  <i className="bi bi-webcam-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Installation de Caméras et Alarmes</h4>
                  <p>
                    Solutions complètes pour la sécurité de votre domicile ou
                    entreprise : installation de caméras de surveillance et
                    systèmes d’alarme.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/domotique.webp"
                    alt="Domotique"
                  />
                  <i className="bi bi-house-gear-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Solutions de Maison Connectée</h4>
                  <p>
                    Automatisez et contrôlez votre maison avec des solutions
                    intelligentes : éclairage, sécurité, chauffage et plus
                    encore.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/marketing.webp"
                    alt="Marketing Digital"
                  />
                  <i className="bi bi-bag-heart-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Marketing Digital</h4>
                  <p>
                    Développez votre visibilité en ligne avec des stratégies de
                    marketing digital efficaces : SEO, réseaux sociaux,
                    publicité en ligne.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/formation.webp"
                    alt="Formation"
                  />
                  <i className="bi bi-pc-display-horizontal"></i>
                </div>
                <div className="service-card-text">
                  <h4>Formations Professionnelles</h4>
                  <p>
                    Des formations pratiques en développement web, mobile,
                    administration système et domotique, adaptées à tous les
                    niveaux.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/flyers.webp"
                    alt="Design Graphique"
                  />
                  <i className="bi bi-door-closed-fill"></i>
                </div>
                <div className="service-card-text">
                  <h4>Conception de Logos et Flyers</h4>
                  <p>
                    Création de logos uniques et de supports de communication
                    visuelle (flyers, affiches, cartes de visite) pour valoriser
                    votre image de marque.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12">
              <div className="service-card">
                <div className="service-card-img">
                  <img
                    src="assets/images/services/consultan.webp"
                    alt="Consultation IT"
                  />
                  <i className="bi bi-laptop"></i>
                </div>
                <div className="service-card-text">
                  <h4>Consultation en IT</h4>
                  <p>
                    Accompagnement et conseils stratégiques en technologies de
                    l'information pour optimiser vos projets et infrastructures.
                  </p>
                  <a style={{ color: "#00aa55" }} href="tel:+237658060432">
                    En savoir plus
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServiceList;
